@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.skeleton {
  padding-top: core.$layout-padding;

  &Content {
    display: flex;
    gap: 16px;
    padding-bottom: 16px;

    &:not(:last-child) {
      border-bottom: 1px solid map.get(core.$colors, lightBlue);
      margin-bottom: 20px;
    }

    &SpaceBetween {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 24px;
    }

    &Section {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
  }

  &Flex {
    display: flex;
    gap: 8px;
  }
}
